var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.335,
    height: 12.72,
    viewBox: "0 0 13.335 12.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39410",
    "data-name": "Group 39410",
    transform: "translate(-7.387 -6.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58725",
    "data-name": "Path 58725",
    d: "M16.379,4.25a.821.821,0,0,0-.445.131,20,20,0,0,0-6.28,6.951L7.936,9.086a.821.821,0,0,0-1.3,1l2.511,3.283a.821.821,0,0,0,1.4-.172A19,19,0,0,1,16.826,5.76a.821.821,0,0,0-.446-1.51",
    transform: "translate(3.521 2.315)",
    fill: "#1c9f00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58726",
    "data-name": "Path 58726",
    d: "M14.629,9.288V14.9H6.423V6.688h6.1a20.078,20.078,0,0,1,1.593-1.641h-7.7A1.641,1.641,0,0,0,4.781,6.688V14.9a1.641,1.641,0,0,0,1.641,1.641h8.207A1.641,1.641,0,0,0,16.271,14.9V7.52a17.276,17.276,0,0,0-1.641,1.768",
    transform: "translate(2.605 2.75)",
    fill: "#1c9f00",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPost);
export default __webpack_public_path__ + "static/media/Dark_Post.81058a5a0c3c7ac56f7ec980ec60306a.svg";
export { ForwardRef as ReactComponent };